export default class LeistungenV2 {
    config = {};

    constructor(elem, config) {
        this.config = {...this.config, ...config};
        this.elem = elem;

        this.open = this.elem.querySelectorAll('.open');
        this.close = this.elem.querySelectorAll('.close');

        this.init();
    }

    init() {
        this.registerEvent();
    }

    registerEvent() {
        this.open.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                const id = e.target.href.split('#')[1];
                const box = this.elem.querySelector(`.${id}`);
                box.classList.add('open');

                // Höhe von this.elem anpassen, falls die Box höher ist
                const boxHeight = box.offsetHeight;
                const elemHeight = this.elem.offsetHeight;

                if (boxHeight > elemHeight) {
                    this.elem.style.height = `${boxHeight}px`;
                }
            });
        });

        this.close.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                element.closest('.open').classList.remove('open');
                this.elem.style.height = ''; // entfernt inline height
            });
        });
    }
}
